import { useState, useCallback } from "react";
import { getAllGroups } from "../../service/GroupService";
import { showErrorMessage,showSuccessMessage } from "../../components/shared/pagination/messages";

export const useGroups = () => {
  const [groupList, setGroupList] = useState([]);

  const fetchGroups = useCallback(async (page, size, isActive, searchText) => {

    try {
      const response = await getAllGroups(page - 1, size, isActive, searchText);
      if (response) {
        const records = response.data?.data.content || [];
        setGroupList(records);
        return response.data.data;
      } else {
        const errMsg = response.data?.message || "Something went wrong.";
        showErrorMessage(errMsg);
      }
    } catch (error) {
       showErrorMessage(error?.message || "Something went wrong.");
    }

  }, []);

  return {
    groupList,
    fetchGroups,
  };
};